/*
 * Main JavaScript file - All global JavaScript is loaded from here
 */

import VModal from 'vue-js-modal';
import FormLoader from 'vue-form-loader';
import PortalVue from 'portal-vue';
import tooltip from '@adaptivemedia/vue-tooltip';
import Vue from 'vue';

window.Vue = Vue; // required for Vue tooltip to work

require('./bootstrap.js');
require('./utils');
require('./fontawesome-front.js');

Vue.use(FormLoader);
Vue.use(VModal);
Vue.use(PortalVue);
Vue.directive('tooltip', tooltip);

Vue.mixin({
    methods: {
        route: typeof Ziggy !== 'undefined' ? window.route : () => console.error('Ziggy not found'),
        formatNumber: window.utils.formatNumber,
        handleNoScrollToggle: window.utils.handleNoScrollToggle,
    },
});

// Components that should always be loaded (almost always visible)
// (always loading these prevents flashing and the UI moving around on load)
Vue.component('alert', require('./Atlantis/Components/Alerts/Alert.vue').default);
Vue.component('flashy-alert', require('./Atlantis/Components/Alerts/FlashyAlert.vue').default);
Vue.component('toggler', require('./Atlantis/Utilities/Toggler.vue').default);
Vue.component('on-click-outside', require('./Atlantis/Utilities/OnClickOutside.vue').default);
Vue.component('header-dropdown', require('./Front/Components/HeaderDropdown').default);
Vue.component('form-modal', require('./Front/Components/FormModal').default);
Vue.component('product-searcher', require('./Front/Components/Product/ProductSearcher').default);
Vue.component('favorite-heart', require('./Front/Components/Product/FavoriteHeart').default);
Vue.component('brand-filter-link', require('./Front/Components/Product/BrandFilterLink').default);
Vue.component('rating-bar', require('./Front/Components/Product/Rating/RatingBar').default);
Vue.component('email-link', require('./Front/Components/EmailLink').default);
Vue.component('notification-bell', require('./Front/Components/NotificationBell').default);

// Components always loaded on specific sites
if (route && route().current() === 'front.products.show') {
    /* eslint-disable global-require */
    Vue.component('nutrition-donut-chart', require('./Front/Components/Product/NutritionDonutChart').default);
    Vue.component('ratings', require('./Front/Components/Product/Rating/Ratings').default);
    Vue.component('comment-form', require('./Front/Components/Product/Comment/CommentForm').default);
    Vue.component('comment', require('./Front/Components/Product/Comment/Comment').default);
    Vue.component('fade-out-text', require('./Front/Components/Product/FadeOutText').default);
}

// General dynamically loaded components (most often not displayed on page load)
Vue.component('text-input', () => import('./Atlantis/Elements/Form/TextInput'));
Vue.component('checkbox-input', () => import('./Atlantis/Elements/Form/CheckboxInput'));
Vue.component('radio-input', () => import('./Atlantis/Elements/Form/RadioInput'));
Vue.component('password-input', () => import('./Atlantis/Elements/Form/PasswordInput'));
Vue.component('select-input', () => import('./Atlantis/Elements/Form/SelectInput'));

// Application specific dynamically loaded components
Vue.component('standard-modal', () => import('./Front/Components/StandardModal'));
Vue.component('users-default-filter-tags', () => import('./Front/Components/Setting/UsersDefaultFilterTags'));
Vue.component('share-url', () => import('./Front/Components/Sharing/ShareUrl'));
Vue.component('share-favorites', () => import('./Front/Components/Sharing/ShareFavorites'));
Vue.component('products-filter-form-panel', () => import('./Front/Components/Product/ProductsFilterFormPanel'));
Vue.component('overlay-panel', () => import('./Front/Components/OverlayPanel'));
Vue.component('edit-avatar', () => import('./Front/Components/Setting/EditAvatar'));
Vue.component('setting-toggle', () => import('./Front/Components/Setting/SettingToggle'));
Vue.component('edit-diet-modal', () => import('./Front/Components/Setting/EditDietModal'));
Vue.component('edit-vegetarian-reasons', () => import('./Front/Components/Setting/EditVegetarianReasons'));
Vue.component('edit-allergies', () => import('./Front/Components/Setting/EditAllergies'));
Vue.component('copy-url-modal', () => import('./Front/Components/Sharing/CopyUrlModal'));

new Vue({ // eslint-disable-line no-new
    el: '#app',
    mounted() {
        FormLoader.autoBindToForms();
    },
});
